import { FormGroup } from "@angular/forms";
import { ApplicationOnCredit } from "@core/services/online-credit/online-credit.model";
import { FormFieldsListItem } from '@shared/models/modal-payment-form.model';


export interface CalculationResult {
  amount?: number;
  period?: number;
  amountDks: number;
  amountWithDks: number;
  amountInput?: string;
  amountWithoutDks: number;
  monthlyPayment: number;
  interestRate: number;
  incInterestRateWithoutInsurance: number;
  maxAmount?: number;
  insurance?: boolean;
}

export interface CalculationConfig {
  minAmount?: number;
  maxAmount?: number;
  amount?: number;
  minPeriod?: number;
  maxPeriod?: number;
  period?: number;
  amountStep?: number;
  periodStep?: number;
  maxAmountOnline?: number;
  maxPeriodOnline?: number;
  insurance?: boolean;
  isSalaryClient?: boolean;
  isEmployeeClient?: boolean;
}

export interface CreateApplicationRequest {
  amount: number;
  insurance: boolean;
  insuranceAmount: number;
  interestRate: number;
  isOnline: boolean;
  monthAmount: number;
  period: number;
}

export interface SelectedOffice {
  backId: string;
  office: any;
}

export interface PersonalDataForm {
  userFormGroup?: FormGroup,
  userFormField?: FormFieldsListItem[],
  additionalFormGroup?: FormGroup,
  additionalFormField?: FormFieldsListItem[],
}

interface OnlineCreditState {
  isOnline: boolean;
  application?: ApplicationOnCredit;
  calculation?: CalculationResult;
  calculationConfig?: CalculationConfig;
  selectedOffice?: SelectedOffice;
  personalData?: PersonalDataForm;
}


export interface ActiveCredit {
  creditCurrency: string;
  creditLimit: number;
  creditSource: string;
  creditType: string;
  id: string;
  monthAmount: number;
  openDate: number; // timestamp
}

export interface ActiveCreditGroupedByType {
  type: string;
  credits: ActiveCredit[]
}


export interface CalculationSettings extends CalculationConfig, CalculationResult {}

export const INITIAL_STATE: OnlineCreditState = {
  isOnline: true,
}
